import React, { ReactElement, useEffect } from 'react';
import { Button } from 'idsk-react-components';
import { useNavigate } from 'react-router-dom';
import PracovnyKrokRequest from '../../../../../../model/pracovnyKrok/PracovnyKrokRequest';
import PracovnyKrokComplete from './PracovnyKrokComplete';
import routes from '../../../../../../routing/routes';
import PracovnyKrokEnum from '../../../../../../model/pracovnyKrok/PracovnyKrokEnum';
import LegislativnyMaterialItem from '../../../../../../model/pracovnyKrok/LegislativnyMaterialItem';
import {
  usePracovnyKrokLegislativnyMaterialContext,
} from '../../../../../../context/PracovnyKrokLegislativnyMaterialContext';
import splitCisloLegMaterialu from '../../../../../../function/splitCisloLegMaterialu';

interface Props {
  legMaterial: LegislativnyMaterialItem;
  pracovnyKrok: PracovnyKrokRequest;
  reloadDetail?: () => void;
  reloadPracovneKroky?: () => void;
  setIsDropdownOpened: (isDropdownOpened: boolean) => void,
}

const UkoncitProces = ({
  legMaterial,
  pracovnyKrok,
  reloadDetail,
  reloadPracovneKroky,
  setIsDropdownOpened,
}: Props): ReactElement => {
  const navigate = useNavigate();
  const {
    type,
    year,
    index,
  } = splitCisloLegMaterialu(legMaterial.cisloLegislativnehoMaterialu);
  const { setMaterial } = usePracovnyKrokLegislativnyMaterialContext();

  useEffect(
    () => setMaterial(legMaterial),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [legMaterial?.uuid, legMaterial?.typ,
      legMaterial?.cisloLegislativnehoMaterialu, setMaterial],
  );

  return (
    <>
      {(pracovnyKrok?.pracovnyKrok === PracovnyKrokEnum.UKONCIT_PROCES_POSLEDNE_STADIUM
        || pracovnyKrok?.pracovnyKrok === PracovnyKrokEnum.UKONCIT_PROCES_BEZ_MPK) ? (
          <PracovnyKrokComplete
            legMaterial={legMaterial}
            pracovnyKrok={pracovnyKrok}
            confirmActionQuestion="Naozaj si prajete ukončiť proces?"
            confirmActionDescription={'Po ukončení procesu už nebude možné vykonávať pracovné kroky a aktuálne štádium'
              + ' materiálu sa zmení na "Proces ukončený".'}
            reloadDetail={reloadDetail}
            reloadPracovneKroky={reloadPracovneKroky}
            setIsDropdownOpened={setIsDropdownOpened}
          />
        )
        : (
          <Button
            className="pracovny-krok__button"
            key={pracovnyKrok.pracovnyKrok}
            size="small"
            to={routes.procesy.terminate.withParams(type, year, index, pracovnyKrok.pracovnyKrokId)}
            buttonStyle="link"
            onClick={() => navigate(
              routes.procesy.terminate.withParams(type, year, index, pracovnyKrok.pracovnyKrokId),
            )}
          >{pracovnyKrok.nazov}
          </Button>
        )}
    </>
  );
};

export default UkoncitProces;
